module.exports = __webpack_public_path__ + "media/images/icons/arrow--down-3d9110d3a6d8fbde833d45727ccb8c9a.svg";